var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "accordion", class: _vm.type },
    _vm._l(_vm.data, function(message, index) {
      return _c(
        "li",
        { key: index, staticClass: "accordion-item" },
        [
          _c(
            "div",
            {
              staticClass: "header",
              class: { open: index === _vm.activeIndex },
              on: {
                click: function($event) {
                  return _vm.openItem(index)
                }
              }
            },
            [
              _vm._v("\n      " + _vm._s(message.title) + "\n      "),
              _c("span", {
                staticClass: "icon",
                class: { rotate: index == _vm.activeIndex }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: { name: "accordion" },
              on: {
                "before-enter": _vm.beforeEnter,
                enter: _vm.enter,
                "before-leave": _vm.beforeLeave,
                leave: _vm.leave
              }
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeIndex === index,
                    expression: "activeIndex === index"
                  }
                ],
                staticClass: "message",
                class: { open: index === _vm.activeIndex },
                domProps: { innerHTML: _vm._s(message.text) }
              })
            ]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }